import {createSlice} from '@reduxjs/toolkit'


import {createUser, validateUser} from './userThunk'

const initialState = {
    isLoggedIn: JSON.parse(localStorage.getItem('user'))?.result?true:false,
    currentUser: JSON.parse(localStorage.getItem('user'))?.result || null,
}
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers:{
        logOut:(state) =>{
            localStorage.removeItem('user');
            state.currentUser = null;
            state.isLoggedIn=false;
        },
        logIn:(state) =>{
            console.log('trying to log in')
        }

    },
    extraReducers: {
        [createUser.fulfilled]: (state, action) => {
          state.isLoggedIn = true;
         localStorage.setItem('user',JSON.stringify(action.payload))
        state.currentUser= JSON.parse(localStorage.getItem('user')).result
        },
         [createUser.pending]: (state, action) => {
        console.log('pending')
        },
         [createUser.rejected]: (state, action) => {
        console.log('rejected')
        },
         [validateUser.pending]: (state, action) => {
         console.log('validation pending')
        },
         [validateUser.fulfilled]: (state, action) => {
         state.isLoggedIn = true;
         localStorage.setItem('user',JSON.stringify(action.payload))
         state.currentUser= JSON.parse(localStorage.getItem('user')).result
        
        },
         [validateUser.rejected]: (state, action) => {
         console.log('rejected')
        },
    },
})

export const {logOut, logIn} = userSlice.actions;
export default userSlice.reducer